//Really just a wrapper on process.env, but allows us to
//introduce custom configuration at a central point.

let Config = {
  ...process.env,
  API_BASE: null,
  SERVICE_BASE: null,
}

export const setApiBaseUrl = (apiBaseUrl) => {
  if (Config.API_BASE !== null) {
    console.warn(
      'setApiBaseUrl should only be called once on application initialization.',
    )
  }

  Config.API_BASE = apiBaseUrl
}

export const setServiceBaseUrl = (serviceBaseUrl) => {
  if (Config.SERVICE_BASE !== null) {
    console.warn(
      'setServiceBaseUrl should only be called once on application initialization.',
    )
  }
  Config.SERVICE_BASE = serviceBaseUrl
}

export default Config
